{
  "global": {
    "action": "Acción",
    "actions": "Acciones",
    "actiontemplate": "action template",
    "actiontemplates": "action templates",
    "add": "Añadir",
    "added": "añadido",
    "area": "Area",
    "areas": "Areas",
    "category": "Categoria",
    "categories": "Categorias",
    "choose": "elije",
    "choose-multi": "elije multiple",
    "choose-date": "elije fecha",
    "check": "check",
    "combined": "combinado",
    "comments": "Commentarios",
    "content": "Contenido",
    "copy": "Copiar",
    "could_not_add": "No podía crear",
    "create": "Crear",
    "crm": "CRM",
    "days": "Días",
    "delete": "Borrar",
    "details": "Detalles",
    "domain": "Dominio",
    "do-not-set": " no elijes",
    "email": "email",
    "encryption": "encryption",
    "file": "fichero",
    "filename": "nombre fichero",
    "format": "formato",
    "found": "encontrado",
    "handling": "handling",
    "history": "historia",
    "identifier": "identificador",
    "lastmodified": "last modified",
    "list": "list",
    "month": "mes",
    "men": "hombres",
    "name": "Name",
    "status": "Status",
    "edit": "Edit",
    "extra": "Extra",
    "filter": "Filtro",
    "active": "Activo",
    "info": "Información",
    "inactive": "Inactivo",
    "ignore": "Ignorar",
    "ignored": "Ignorado",
    "male": "Male",
    "female": "Female",
    "type": "Type",
    "all": "todos",
    "more": "más",
    "mandatoryfields": "Mandatory fields",
    "or": "or",
    "orderby": "Order by",
    "other": "other",
    "from": "From",
    "prefill": "Prefill",
    "to": "To",
    "yes": "Yes",
    "limit": "limit",
    "no": "No",
    "null": "NULL",
    "mode": "Mode",
    "in": "In",
    "not-in": "Not in",
    "date": "date",
    "search": "search",
    "set": "set",
    "source": "Source",
    "sources": "Sources",
    "setting": "Setting",
    "use": "use",
    "show": "show",
    "sum": "sum",
    "upload": "Subir",
    "user": "Usuario",
    "users": "Usuarios",
    "title": "título",
    "total": "Total",
    "women": "mujeres"
  },
  "actions": {
    "age": "Edad",
    "add": "crear action",
    "add_template": "Crear template",
    "address": "Address",
    "ages-gender-ratios": "ages gender ratios",
    "autonom-regions": "Autonom regions",
    "amount": "Cantidad",
    "blacklist": "Blacklist",
    "blacklists": "Blacklists",
    "block": "Block",
    "blocks": "Blocks",
    "block-days": "block para días",
    "blocked-users": "usuarios bloqueados",
    "brutos_no_optouts": "no optouts for brutos",
    "dependants": "Dependants",
    "checking": "Just checking",
    "children": "Niños",
    "clone": "Clon",
    "commaorspaceseparated": "comma or space separated",
    "counting": "Counting",
    "created": "Acción Creado",
    "credit_amount": "Credit amount",
    "credit_status": "Credit status",
    "credit_period": "Credit period",
    "cycleaction": "Acción cíclico",
    "data-created": "Data creado",
    "days-from-delivery": "days from scheduledate or delivery",
    "deliver": "Entregar",
    "delivery": "Entrega",
    "delivered": "entregado",
    "delivery-data": "Fecha entrega",
    "download": "download",
    "duplicates": "duplicados",
    "grossdelivered": "§ntregado bruto",
    "create-data": "Crear dato",
    "recreate-raw-data": "Recrear raw data",
    "create-raw-data": "Crear raw data",
    "deliveryformat": "formato de entrega",
    "formatteddelivery": "Formatted Delivery",
    "in-past-days": "en los ultimos * días",
    "formatcsv": "formato csv",
    "exclude-global-unsubs": "exclude global unsubscribes",
    "estimated": "estimado",
    "getamount": "contar usuarios",
    "impact": "Impact",
    "block-until": "Bloquear hasta",
    "capitals": "Capital cities",
    "check-robinson": "Check Robinson",
    "consent-3rds": "Consent 3rds",
    "delete": "Borrar acción",
    "delivered-to": "Delivered to",
    "exclude-actions": "Excluir acciones",
    "exclude_only": "exclude only",
    "doi": "DOI",
    "education": "Educación",
    "email": "email",
    "executiondate": "Execution date",
    "exclude-users-delivered": "Excluir usuarios entregados",
    "fileheader": "header fichero",
    "select-only-users-delivered": "Select only delivered users",
    "gender": "Género",
    "home_status": "Home status",
    "income_source": "Income source",
    "keep_gross": "keep gross status",
    "last_phonecheck": "last phone check",
    "marital_status": "Martital status",
    "monthly_income": "Monthly income",
    "new-amount": "New amount",
    "howmanykids": "How many",
    "scheduledate": "Schedule date",
    "list": "List actions",
    "title": "Action Title",
    "include-blocks": "Include blocks",
    "job_area": "Job area",
    "job_start": "Job start",
    "exclude-global-blocks": "Exclude global blocks",
    "exclude-all-blocks": "Exclude all blocks",
    "filter-content": "Filter content",
    "geotargeting": "Geo targeting",
    "firstuse": "First use",
    "fixed-phone": "Fixed phone",
    "is-robinson": "Is Robinson",
    "keep_status_gross": "keep status gross",
    "mobile-phone": "Mobile phone",
    "mobile-operators": "Mobile operator",
    "mobile-or-fix": "Mobile or fix phone",
    "nationalities": "Nationalities",
    "phonefilter": "Phone filter",
    "search-criteria": "Search criteria",
    "masculin": "only men",
    "participations": "Participations",
    "percentage": "Percentage",
    "postprocessfilter": "Postprocess filter",
    "postprocessfilters": "Postprocess filters",
    "feminin": "only women",
    "birthday": "Birthday",
    "haschildren": "Has children",
    "querydetails": "Query details",
    "random": "Random",
    "ratio": "ratio",
    "reasons": "Reasons",
    "reduce": "Reduce",
    "regdate": "Regdate",
    "regdate_asc": "Regdate (registros más viejos)",
    "regdate_desc": "Regdate (registros más recientes)",
    "regions": "Provinces",
    "robinsonspares": "Robinson spares",
    "mailing": "Mailing",
    "postprocess": "post process",
    "phone": "Phone",
    "restofregion": "Rest of region",
    "send_data_as": "You are about to send the data as",
    "set_equally": "Distribuir uniformemente",
    "sms": "SMS",
    "subids": "Subids",
    "startdate": "Start date",
    "totalamount": "Total amount",
    "uniqueid": "unique id",
    "uniqueids": "unique ids",
    "upload_nets": "upload nets",
    "use-csv": "Use csv",
    "use-all": "Use all",
    "use-postprocess": "Use postprocess",
    "vehicle_type": "Vehicle type",
    "zip": "postal code",
    "will_be_marked_as_delivered": "Action will be marked as delivered!!!",
    "withaddress": "with address",
    "withfulladdress": "with full address (incl. floor)",
    "withfulladdressnofloor": "with full address (excl. floor)",
    "withoutcapitals": "sin capital cities"
  },
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña",
    "username": "Username",
    "permissions": "Permisiones",
    "edit": "edit",
    "delete": "borrar",
    "extra": "extra",
    "read": "read",
    "add": "crear",
    "set-permissions": "Set permissons"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "crm": {
    "adjustment": "ajustamiento",
    "anonymize": "anonimizar",
    "beneficiary": "Beneficiario",
    "beneficiaries": "Beneficiarios",
    "city": "Ciudad",
    "client": "Cliente",
    "clients": "Clientes",
    "client_added": "Cliente creado",
    "country": "País",
    "could_not_add_client": "No podía crear cliente",
    "could_not_create_action": "No podía crea acción",
    "company": "Nombre compania",
    "computed": "computed",
    "controlling": "controlling",
    "cpa": "CPA",
    "cpl": "CPL",
    "default_values": "valores default",
    "delivery_formats": "Formatos entrega",
    "delivery_settings": "Settings entrega",
    "divider": "Divider",
    "fields": "Fields",
    "gross": "bruto",
    "invoice": "Invoice",
    "invoice-amount": "Inv. Sum",
    "invoice-nr": "Inv. Number",
    "invoice-not-sent": "Invoice not sent",
    "invoice-open": "Inv. open",
    "invoice-paid": "Inv. paid",
    "invoice-provision": "Inv. provision",
    "io": "insertion order",
    "finance": "Finance",
    "partner": "Partner",
    "partners": "Partneres",
    "pay_type": "Tipo de pago",
    "pending": "pending",
    "persistent": "keep old data",
    "petitions": "Peticiones",
    "provider": "Provider",
    "province": "Provincia",
    "net": "net",
    "shortname": "Shortname",
    "contact": "Contact name",
    "broker": "Broker",
    "role": "Role",
    "roles": "Roles",
    "street": "Street",
    "treater": "Treater",
    "vatid": "Vat id",
    "inform_optouts": "inform about optouts",
    "inform_optouts_settings": "inform optouts setting",
    "inform_optouts_partnersettings": "Inform optouts (partneres)",
    "recipient": "Recipiente",
    "recipients": "Recipientse",
    "samples_regarding": "Samples regarding",
    "subject": "Sujeto",
    "universal": "Universo"
  },

  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "petitiontemplates": "Petition templates",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "uploadunsubscribes": "subir bajas",
    "users": "Usuarios admin"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Subir archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Seleccionar una opción"
  }
}
